import { Injectable, inject } from '@angular/core';
import { UploadApi } from '@reconcept-platform/shared/data-access';
import { type CreateCardCommentInput, type UpdateCardCommentInput } from '@reconcept-platform/shared/types';
import { type SelectedFile } from '@reconcept-platform/shared/util';
import { CommentApi } from '../../api/comment/comment.api';

@Injectable({
  providedIn: 'root',
})
export class CommentService {
  private commentApi = inject(CommentApi);
  private uploadApi = inject(UploadApi);

  createComment(createCardCommentInput: CreateCardCommentInput) {
    return this.commentApi.createCardComment(createCardCommentInput);
  }

  updateComment(updateCardCommentInput: UpdateCardCommentInput, cardId: string) {
    return this.commentApi.updateCardComment(updateCardCommentInput, cardId);
  }

  destroyComment(cardId: string, cardCommentId: string) {
    return this.commentApi.destroyCardComment(cardId, cardCommentId);
  }

  watchCardCommentAttachedFiles(commentId: string) {
    return this.commentApi.watchCardCommentAttachedFiles(commentId);
  }

  // destroy an attached file that's already connected server side
  destroyAttachedFile(fileId: string) {
    // destroy and reload attachments
    return this.uploadApi.destroyAttachedFile(fileId);
  }

  createDirectUploadsAndUploadFiles(files: SelectedFile[]) {
    // create a DirectUpload object and upload the file
    return this.uploadApi.createDirectUploadsAndUploadFiles(
      files,
      'Er is iets foutgegaan bij het uploaden van je bestand',
    );
  }
}
